import { ProcessType } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { ProcessPaperLayout } from "~/areas/projects/components/Process/CustomPaperLayouts/ProcessPaperLayout";
import { useProjectContext } from "~/areas/projects/context/index";
import { ProcessCodeLayout } from "./ProcessCodeLayout";
export function DeploymentProcessCodePage() {
    const context = useProjectContext();
    if (!context.state.model) {
        return <ProcessPaperLayout processType={ProcessType.Deployment} busy={true}/>;
    }
    return <ProcessCodeLayout processId={context.state.model.DeploymentProcessId} processType={ProcessType.Deployment} project={context.state.model} gitRef={context.state.gitRef} changeGitRef={context.actions.changeGitRef}/>;
}
